import axios from 'axios';
import { GET_PRODUCT, GET_ADDRESS_SEARCH, GET_ADDRESS_DETAIL, POST_FORM_SUBMIT } from './endpoints';
import { isValid } from '@utils';
const API = axios.create();

export const fetchProductCode = async (payload: any) => {
  let lotNo = payload[0];
  const country = payload[2];
  const region = payload[3];
  if(isValid(lotNo)) lotNo = lotNo.trim().toUpperCase();
   const newPayload = {
    lotNo:lotNo,
    country:country,
    region:region
  } 
  try{
  let response = await API.post(GET_PRODUCT, newPayload);
  return response.data ? response.data : [];
  }
  catch(error)
  {
    console.log("<!!!!!",error)
    console.log("<!!!!!!",payload)
  }
  // return [];

  // return {
  //   "region": "USA",
  //   "products": [
  //     {
  //       "lotNo": "690937",
  //       "productCode": "5C8310RU",
  //       "ndcNo": "111111111111111",
  //       "udiNo": "00085412349275",
  //       "productName": "REFURB,HOMECHOICE PRO,V10.4    SOFTWARE UPGRADE              ",
  //       "productType": "SOLUTIONS",
  //       "productFamily": "ACCESS - BLOOD - SOLUTION SETS",
  //       "drugsAndBiologics": null,
  //       "hardware": null
  //     }
  //   ]
  // }
};

export const fetchProductData = async (payload: any) => {
  let lotNo = payload[0];
  const country = payload[2];
  const region = payload[3];
  const lotNotFound = payload[4];

  if (isValid(lotNo) && lotNotFound) {
    lotNo = 'unknown';
  }
  else if (isValid(lotNo)) {
    lotNo = lotNo.trim().toUpperCase();
  }

  let pcode = '';
  if(payload && payload[1]) 
  {
    let tempPcode = payload[1];
    pcode = tempPcode.trim().toUpperCase()
  }

  const newPayload = {
    code:pcode,
    lotNo:lotNo,
    country:country,
    region:region
  } 

  let response = await API.post(GET_PRODUCT, newPayload);
  return response.data ? response.data : [];

  // return [];

  // return {
  //   "region": "USA",
  //   "products": [
  //     {
  //       "lotNo": "690937",
  //       "productCode": "5C8310RU",
  //       "ndcNo": "ABCD",
  //       "udiNo": "00085412349275",
  //       "productName": "REFURB,HOMECHOICE PRO,V10.4    SOFTWARE UPGRADE              ",
  //       "productType": "ACCESS",
  //       "productFamily": "ACCESS - BLOOD - SOLUTION SETS",
  //       "drugsAndBiologics": null,
  //       "hardware": null
  //     }
  //   ]
  // }
};

export const fetchCountryRegion = async (payload: any) => {
  const lotNo = payload[0];
  const country = payload[2]; 
  
  const newPayload = {
    lotNo:lotNo,
    country:country,
  }

  let response = await API.post(GET_PRODUCT, newPayload);
  return response.data.region || '';
};

export const searchAddress = async (searchText: string, countryCode: string) => {
  const response = await API.get(`${GET_ADDRESS_SEARCH}?key=${searchText}&filtercountries=${countryCode}&language=${localStorage?.getItem('i18nextLng')}`);
  return response ? response.data : [];
};

export const fetchSelectedAddress = async (searchText: string, countryCode: string) => {
  const response = await API.get(`${GET_ADDRESS_DETAIL}?key=${searchText}&filtercountries=${countryCode}&language=${localStorage?.getItem('i18nextLng')}`);
  return response.data;
};

export const fetchEmployeeInfo = async (userId: string, password: string) => {
  // Placeholder for OKTA API
  return '';
};


async function fetchDataWithRetry(maxRetries = 3, delay = 1000, payload: any) {
  let retries = 0;
  let outError = "";
  let response = "";
  while (retries < maxRetries) {
      try {
        //await new Promise(resolve => setTimeout(resolve, 1000));
          let response = await API.post(POST_FORM_SUBMIT, payload);
          console.log('<!!!!!! ',response)
          if (response) {
            if (response.data.message == "INTERNAL_SERVER_ERROR"  && response.data.referenceNumber == null)
            {
              //TrackWise Error
              response.status = 503
              retries=maxRetries
            }
            else
            {
              return response
            }
          } else {
              retries++;  
              console.log(`Response undefined, retrying (${retries}/${maxRetries})...`);
              await new Promise(resolve => setTimeout(resolve, delay)); // Wait before retrying
          }
      } catch (error: unknown) {
        if (error instanceof Error) {
          // Handle Error object
          const err = error as Error;
          if (err.message =='Network Error')
          {
            console.log("Network Error")
            outError = "Network Error"
            console.error(`Error during fetch, retrying (${retries}/${maxRetries}):`, error);
            retries++;
            await new Promise(resolve => setTimeout(resolve, delay)); // Wait before retrying
          }
          else if (err.message =='Request failed with status code 504')
            {
              console.log("500")
              outError = "500"
              //console.error(`Error during fetch, retrying (${retries}/${maxRetries}):`, error);
              retries = maxRetries
              //await new Promise(resolve => setTimeout(resolve, delay)); // Wait before retrying
            }
          else
          {
            retries++;
            console.error(`Error during fetch, retrying (${retries}/${maxRetries}):`, error);
            console.error("Error:", error.message);
            await new Promise(resolve => setTimeout(resolve, delay)); // Wait before retrying
          }
        }
         else {
          // Handle other types of errors or non-error values
          retries++;
          console.error(`Error during fetch, retrying (${retries}/${maxRetries}):`, error);
          
          await new Promise(resolve => setTimeout(resolve, delay)); // Wait before retrying
          console.error("Unknown error:", error);
        }
          
      }
  }
  throw new Error(`Failed to fetch data after ${maxRetries} retries. ${outError}`);
}

export const submitForm = (payload: any, successCall: any, onSubmitErr:any) => { //minute to get this data back from SubmitFormValues
  try{  
      console.log("Inside Submit Form.")
      fetchDataWithRetry(3, 4000, payload)
      .then(response => 
        {
          console.log('Final response:', response)
          if (response.data.message === "INTERNAL_SERVER_ERROR" && response.data.referenceNumber == null)
          {
            response.status = 503
            response.statusCode = 503
            console.log("00000 ", response)
            onSubmitErr()
          }
          else
          {
            successCall();
            console.log("Sucess",response)
            return response.data ? response.data : [];
          }
        
        return response.data ? response.data : [];

        }
      )
      .catch(error => 
      {
        console.error('Final error:', error)
        if (("1"+error).includes("504")) //error is a Object, This is not hitting here because we are returnging. Catchall incase the return fails in the rety functin verivy error is not 504
          successCall()
        else
          onSubmitErr()
      }
    );
  }
  catch(err){
    onSubmitErr();
    console.log('Submit request failed!!!!!1111', err);
    throw err;

  }
};